<template>
  <div>
    <field-select-module
      title="작성자 정보"
      :visible-field-form="false"
      :board="this.board"
      :is-print="isPrint"
      v-model="form.stdInfo"
    />

    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육내용</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>구분</div>
          <vs-select class="w-full flex-1" autocomplete v-model="form.구분">
            <vs-select-item v-for="option in ['상반기', '하반기']" :key="option" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>학교(기관)명</div>
          <field-selector v-model="form.stdInfo.field_id" :field-name="form.stdInfo.field_name" :readonly="board.readonly" @select="onSelectFieldSelector" />
        </div>
        <div>
          <div>교육구분</div>
          <vs-select class="w-full flex-1" autocomplete v-model="form.교육구분">
            <vs-select-item v-for="option in ['정기교육', '채용시 교육']" :key="option" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>업무분야</div>
          <vs-select class="w-full flex-1" autocomplete v-model="form.업무분야">
            <vs-select-item v-for="option in ['급식', '시설관리', '미화', '통학차량']" :key="option" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>세부직종</div>
          <vs-select class="w-full flex-1" autocomplete v-model="form.세부직종">
            <vs-select-item v-for="option in getOption_세부직종" :key="option" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>성명</div>
          <ml-input v-model="form.성명" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>이수여부</div>
          <vs-select class="w-full flex-1" autocomplete v-model="form.이수여부">
            <vs-select-item v-for="option in ['이수', '미이수']" :key="option" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>이수방법</div>
          <vs-select class="w-full flex-1" autocomplete v-model="form.이수방법">
            <vs-select-item v-for="option in ['원격교육', '집합교육', '현장교육(자체)']" :key="option" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>이수시간</div>
          <ml-input v-model="form.이수시간" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>수료일자</div>
          <date-selector v-model="form.수료일자" :readonly="board.readonly"/>
        </div>
        <div>
          <div>수료기관</div>
          <ml-input v-model="form.수료기관" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>미이수 사유</div>
          <ml-input v-model="form.미이수사유" :readonly="board.readonly" placeholder="입력필드" />
        </div>
      </div>

    </div>

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector,
    FieldSelector,
    FileUploadModule,
    FieldSelectModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    getOption_세부직종 () {
      const option = {
        '급식': ['영양교사', '영양사', '조리사', '조리실무사', '배식실무사', '기타'],
        '시설관리': ['시설직 공무원', '시설관리원', '시설기능공', '수영장운영인력', '시설관리보조', '기타'],
        '미화': ['미화원', '미화보조', '기타'],
        '통학차량': ['통학차량보조', '기타'],
      }
      return option[this.form.업무분야]
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.업무분야'() {
      if (!this.getOption_세부직종.includes(this.form.세부직종)) {
        this.form.세부직종 = '';
      }
    },
    'form.학교명'() {
      if (this.form.학교명) {
        this.form.stdInfo.field_id = parseInt(this.form.학교명 || '0');
      }
    },
  },
  data() {
    return {
      form: {
        "stdInfo": {},
        "fileList": [],
        "구분": '',
        "학교명": '',
        "교육구분": '',
        "업무분야": '',
        "세부직종": '',
        "성명": '',
        "이수여부": '',
        "이수방법": '',
        "이수시간": '',
        "수료일자": '',
        "수료기관": '',
        "미이수사유": '',
      }
    };
  },
  methods: {
    onSelectFieldSelector(value) {
      this.form.stdInfo.field_name = value.field_name;
      this.form.stdInfo.field_address = value.address;
    },
  }
};
</script>

<style scoped lang="scss"></style>
